export default "__VITE_ASSET__054e0b5a__"